module.exports = __webpack_public_path__ + "static/img/rppghealthappbs2.3b10957.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rppghealth/rppghealthappbs2.png
// module id = uGhn
// module chunks = 4